import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M5.808 7.292h-.417a.833.833 0 0 0-.833.833v4.583c0 .46.373.834.833.834h.417c.46 0 .833-.373.833-.834V8.125a.833.833 0 0 0-.833-.833Zm5-3.334h-.417a.833.833 0 0 0-.833.834v7.916c0 .46.373.834.833.834h.417c.46 0 .833-.373.833-.834V4.792a.833.833 0 0 0-.833-.834Zm-6.25 12.084h12.083m-.833-8.75h-.417a.833.833 0 0 0-.833.833v4.583c0 .46.373.834.833.834h.417c.46 0 .833-.373.833-.834V8.125a.833.833 0 0 0-.833-.833Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);